<div class="flex jc-c ai-c gap-1" [ngClass]="isResults? 'res-right-nav': ''"
  [ngStyle]="isResults? {'height': '5em'}: {}">
  <div class="nav__item flex ai-c jc-c" (click)="goToPropertyReg()" [hidden]="userlogged || inSearch">
    <a data-toggle="modal" data-backdrop="false" placement="bottom">
      <svg id="nav__icon--house" class="nav__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 102.31 93">
        <polygon
          points="100.81 43.26 90.73 43.26 90.73 91.5 59.34 91.5 59.34 62.44 42.97 62.44 42.97 91.5 11.16 91.5 11.16 43.26 1.5 43.26 51.16 1.5 100.81 43.26" />
      </svg>
      List your Property
    </a>
  </div>

  <!-- Displays login and register buttons for desktop and tablet devices -->
  <div *ngIf="(!isLoggedIn && !isMobile())" class="flex gap-1">
    <a class="nav__button" data-toggle="modal" data-backdrop="false" (click)="goToLoginPage('signup')"
      placement="bottom">Register</a>
    <a class="nav__button" data-toggle="modal" data-backdrop="false" (click)="goToLoginPage('login')"
      placement="bottom">Login</a>
  </div>

  <div *ngIf="userlogged" class="flex gap-1">
    <div *ngIf="showNewRequestBtnHeader && !isMobile()" class="nav__item nav__item--secondary">
      <a (click)="goToNewSearch(); angulartics2Track('NewRequestClicked')">New
        Request</a>
    </div>
    <div class="nav__item nav__item--main">
      <div (click)="dashMenuOpen = !dashMenuOpen; accountMenuOpen = false;" title="My Dashboard">
        <svg (click)="angulartics2Track('DashboardClickedOuter')" id="nav__icon--dashboard" class="nav__icon"
          xmlns="http://www.w3.org/2000/svg" viewBox="0 0 142.19 92.97">
          <g id="Layer_2" data-name="Layer 2">
            <rect class="dashboard__bg" x="1.5" y="1.5" width="139.19" height="89.97" rx="10" />
            <path class="cls-1"
              d="M63.68,73.91H21V66.45A16.93,16.93,0,0,1,37.94,49.53h8.83A16.92,16.92,0,0,1,63.68,66.45h0Z" />
            <circle class="cls-1" cx="42.35" cy="31.25" r="12.19" />
            <rect class="cls-1" x="73.7" y="61.72" width="47.47" height="11.92" rx="5.96" />
            <rect class="cls-1" x="73.7" y="40.39" width="47.47" height="11.92" rx="5.96" />
            <rect class="cls-1" x="73.7" y="19.06" width="47.47" height="11.92" rx="5.96" />
          </g>
        </svg>
        Dashboard
        <span *ngIf="requestCount > 0" class="subnav__notif-empty"></span>
      </div>
      <ul *ngIf="dashMenuOpen" class="subnav">
        <li class="subnav__item">
          <a (click)="angulartics2Track('RequestsClicked')" class="subnav__link" routerLink="/my-dashboard/my-requests"
            title="My Requests">
            <span *ngIf="requestCount > 0" class="subnav__notif-empty"></span>Requests</a>
        </li>
        <li class="subnav__item">
          <a (click)="angulartics2Track('BookingsClicked')" class="subnav__link" routerLink="/my-dashboard/my-bookings"
            title="My Bookings">Bookings</a>
        </li>
        <li class="subnav__item">
          <a (click)="angulartics2Track('SettingsClicked')" class="subnav__link" routerLink="/my-dashboard/my-settings"
            title="My Settings">Settings</a>
        </li>
      </ul>
    </div>
  </div>

</div>

<ul *ngIf="userlogged && isMobile() && mobileMenuOpen" class="nav-bar nav right-nav-menu mobile-dropdown-nav"
  [ngClass]="isResults? 'res-right-nav': ''">
  <li *ngIf="(isResults || isHome || isBooking) && userlogged && (!isMobile() || mobileMenuOpen)" id="requests"
    [ngClass]="isHome? 'nav-item home-nav-item': 'nav-item'" style="background: none; border: none; padding: 0px 8px;">
    <a (click)="toggleMobileMenu();" routerLink="/my-dashboard/my-requests" title="My Requests"><img
        src="../../../../../assets/img/icons/requests_icon.svg" alt="Requests Icon" /><span
        class="subnav__notif">{{requestCount}}</span></a>
  </li>
  <li *ngIf="(isResults || isHome || isBooking) && userlogged && (!isMobile() || mobileMenuOpen)"
    [ngClass]="isHome? 'nav-item home-nav-item': 'nav-item'" style="background: none; border: none; padding: 0px 8px;">
    <a (click)="toggleMobileMenu();" routerLink="/my-dashboard/my-bookings" title="My Bookings"><img
        src="../../../../../assets/img/icons/bookings_icon.svg" alt="Booking Icon" /></a>
  </li>
  <li *ngIf="(isResults || isHome || isBooking) && userlogged && (!isMobile() || mobileMenuOpen)"
    [ngClass]="isHome? 'nav-item home-nav-item': 'nav-item'" style="background: none; border: none; padding: 0px 8px;">
    <a (click)="toggleMobileMenu();" class="icon icon-settings" routerLink="/my-dashboard/my-settings"
      title="My Settings"></a>
  </li>
  <li *ngIf="(isResults || isHome || isBooking) && userlogged && (!isMobile() || mobileMenuOpen)"
    [ngClass]="isHome? 'nav-item home-nav-item': 'nav-item'" style="background: none; border: none; padding: 0px 10px;">
    <a id="logout-btn" style="display: block; font-size: 14px;" (click)="logoutUserMobile()"><span>Logout</span></a>
  </li>
</ul>